import {
  SET_ETHNICITY_SUCCESS,
  UPLOAD_IMAGE_SUCCESS,
  POST_AGE_FACE_SUCCESS,
  GET_FACE_IMAGE_SUCCESS,
  POST_RE_AGE_SUCCESS,
  CONFIRM_PHOTO_UPLOAD_SUCCESS,
  CONFIRM_WEBCAM_PHOTO_SUCCESS,
  CONFIRM_WEBCAM_PHOTO_ERROR,
  RESET_FACE_AGEING_PAGE,
  SET_AGE_FACE_PARAMS,
  GET_AGING_STATUS_SUCCESS,
  SUBMIT_PHOTO_BEGIN,
  SUBMIT_PHOTO_ERROR,
  SET_ETHNICITY_BEGIN,
  UPLOAD_IMAGE_BEGIN,
  POST_AGE_FACE_BEGIN,
  GET_FACE_IMAGE_BEGIN,
  GET_AGING_STATUS_BEGIN,
  POST_RE_AGE_BEGIN,
} from "actions/faceAgeingActions";

const initialState = {
  setEthnicityResponse: null,
  uploadImageResponse: null,
  ageFaceResponse: null,
  getImageResponse: null,
  reAgeResponse: null,
  getAgingStatusResponse: null,
  uploadPhotoCompleted: false,
  takePhotoCompleted: false,
  ageFaceParams: null,
  submitting: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ETHNICITY_SUCCESS:
      return { ...state, setEthnicityResponse: action.payload };

    case UPLOAD_IMAGE_BEGIN:
      return { ...state, uploadImageResponse: null };

    case UPLOAD_IMAGE_SUCCESS:
      return { ...state, uploadImageResponse: action.payload };

    case POST_AGE_FACE_SUCCESS:
      return { ...state, ageFaceResponse: action.payload };

    case GET_FACE_IMAGE_SUCCESS:
      return { ...state, getImageResponse: action.payload };

    case POST_RE_AGE_SUCCESS:
      return { ...state, reAgeResponse: action.payload };

    case CONFIRM_PHOTO_UPLOAD_SUCCESS:
      return {
        ...state,
        uploadPhotoCompleted: true,
        submitting: false,
      };

    case CONFIRM_WEBCAM_PHOTO_ERROR:
      return {
        ...state,
        uploadPhotoCompleted: false,
        submitting: false,
      };

    case SET_ETHNICITY_BEGIN:
    case POST_AGE_FACE_BEGIN:
    case GET_FACE_IMAGE_BEGIN:
    case GET_AGING_STATUS_BEGIN:
    case POST_RE_AGE_BEGIN:
      return { ...state, submitting: false };

    case SUBMIT_PHOTO_BEGIN:
      return { ...state, submitting: true };

    case CONFIRM_WEBCAM_PHOTO_SUCCESS:
      return { ...state, takePhotoCompleted: true, submitting: false };

    case SUBMIT_PHOTO_ERROR:
      return { ...state, submitting: false };

    case RESET_FACE_AGEING_PAGE:
      return initialState;

    case SET_AGE_FACE_PARAMS:
      return { ...state, ageFaceParams: action.payload };

    case GET_AGING_STATUS_SUCCESS:
      return { ...state, getAgingStatusResponse: action.payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/faceAgeingReducer.js